import { render, staticRenderFns } from "./FrontPageHero.vue?vue&type=template&id=b83f3238&"
import script from "./FrontPageHero.vue?vue&type=script&lang=js&"
export * from "./FrontPageHero.vue?vue&type=script&lang=js&"
import style0 from "./FrontPageHero.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports